import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "game-help" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "How to play?"),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode(" As the name suggests you need to sum up all numbers in the squares. You will have "),
    /*#__PURE__*/_createElementVNode("i", null, [
      /*#__PURE__*/_createElementVNode("strong", null, "90")
    ]),
    /*#__PURE__*/_createTextVNode(" to solve as many as such tasks as you can. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("i", null, "Be aware some number might be negative, which means you need to consider subtraction."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Pick the right solution from the buttons at the bottom. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("i", null, "Good luck, have fun!")
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}